'use client'

import { useSearchParams } from 'next/navigation'

import { useRouter } from '@/shared/i18n'

export const usePagination = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const page = Number(searchParams?.get('page')) || 1

  const handlePageChange = (newPage: number) => {
    const params = new URLSearchParams(searchParams?.toString() ?? '')

    if (newPage === 1) {
      params.delete('page')
    } else {
      params.set('page', newPage.toString())
    }

    router.push(`?${params.toString()}`)
  }

  return { page, handlePageChange }
}
